<template>
    <el-container v-loading="loading" width="1200px" height="800px">
        <el-dialog
                :title="data.files[0].name"
                :visible.sync="dialogVisible"
                :before-close="handleClose"
                fullscreen
                sryle="margin-top: 0px;"
                class="track_modal"
                center>
            <el-header width="100%" height="50px">
                <el-form :inline="true" ref="raceForm" :model="$data.raceParams" :rules="$data.rules">
                    <el-form-item :label="$t('track.editForm.fieldCompetitor')" prop="competitor">
                        <el-select
                                v-model="$data.raceParams.competitor"
                                filterable
                                :placeholder="$t('track.editForm.placeHolder.fieldCompetitor')">
                            <el-option
                                    v-for="item in devices"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                <span style="float: left">{{ item.label }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.phone }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('track.editForm.fieldTrackInterval')" prop="selectedIntreval">
                        <el-date-picker
                                v-model="$data.raceParams.selectedIntreval"
                                type="datetimerange"
                                :range-separator="$t('track.editForm.placeHolder.fieldTrackIntervalRangeSeparator')"
                                align="right"
                                :start-placeholder="$t('track.editForm.placeHolder.fieldTrackIntervalStart')"
                                :end-placeholder="$t('track.editForm.placeHolder.fieldTrackIntervalFinish')"
                                default-value="2010-10-01"
                                value-format="timestamp"
                                :format="$t('common.dateTimeFullFormatTemplate')">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('track.editForm.fieldModel')" prop="model">
                        <el-select
                                v-model="$data.raceParams.model"
                                filterable
                                :placeholder="$t('track.editForm.placeHolder.fieldModel')">
                            <el-option
                                    v-for="item in sportClass"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </el-header>
            <el-main>
                <div id="cesiumContainer">
                    <div id="trackCesiumContainer"></div>
                </div>
            </el-main>
            <el-footer align="right">
                <el-button @click="handleSave" type="primary">{{$t('track.buttonSave')}}</el-button>
                <el-button @click="handleClose">{{$t('track.buttonClose')}}</el-button>
            </el-footer>
        </el-dialog>
    </el-container>
</template>

<script>
    import Vue from 'vue';
    import {getDevices} from "@/api/device";
    import TrackUtils from '@/api/track';
    import Utils from '@/utils';
    import {format} from 'date-fns';
    import SportClassUtils from '@/api/sportClass';

    export default {
        name: "TrackCesiumModal",
        mounted: function () {
            this.$nextTick(_ => {
                this.init();
                if (!window.viewer) {
                    let providerViewModels = [];
                    providerViewModels.push(new window.window.Cesium.ProviderViewModel({
                        name: 'ESRI World Imagery',
                        tooltip: '',
                        iconUrl: window.window.Cesium.buildModuleUrl('Widgets/Images/ImageryProviders/esriWorldImagery.png'),
                        creationFunction: function () {
                            return new window.window.Cesium.ArcGisMapServerImageryProvider({
                                url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer',
                                enablePickFeatures: false
                            });
                        }
                    }));
                    window.viewer = new window.window.Cesium.Viewer('trackCesiumContainer', {
                        imageryProviderViewModels: providerViewModels,
                        selectedImageryProviderViewModel: providerViewModels[2],
                        terrainProviderViewModels: [], // Disable terrain changing
                        infoBox: true, // Disable InfoBox widget
                        selectionIndicator: false, // Disable selection indicator
                        sceneMode: window.Cesium.SceneMode.SCENE3D,
                        mapMode2D: window.Cesium.MapMode2D.ROTATE,
                        timeline: false,
                        animation: false,
                        requestRenderMode: true
                    });
                    window.viewer.extend(window.Cesium.sliderMixin, {
                        Vue, format
                    });
                    window.viewer.extend(window.Cesium.viewerCesiumNavigationMixin, {});
                    window.viewer.slider.$on('limitsChange', val => {
                        this.entity = window.viewer.dataSources.get(0).entities._entities._array[0];
                        this.entity.orientation = new window.window.Cesium.VelocityOrientationProperty(this.entity.position);
                        this.entity.availability = this.changeTimeInterval(val);
                        this.updateInterval(val);
                    });
                }
                if (window.viewer.dataSources.length) {
                    window.viewer.dataSources.removeAll();
                }
                window.viewer.dataSources.add(window.Cesium.GpxDataSource.load(this.data.files[0])).then(function (dataSource) {
                    window.viewer.flyTo(dataSource.entities);
                    window.viewer.slider.setTimelineInterval(
                        window.Cesium.JulianDate.toDate(dataSource.clock.startTime).getTime(),
                        window.Cesium.JulianDate.toDate(dataSource.clock.stopTime).getTime()
                    );
                    window.viewer.clock.currentTime = dataSource.clock.stopTime;
                    window.viewer.shouldAnimate = false;
                    window.viewer.slider.$emit('limitsChange', [window.Cesium.JulianDate.toDate(dataSource.clock.startTime).getTime(), window.Cesium.JulianDate.toDate(dataSource.clock.stopTime).getTime()]);
                });
            });
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data() {
            return {
                loading: true,
                devices: [],
                sportClass: [],
                entity: null,
                raceParams: {
                    competitor: null,
                    selectedIntreval: '',
                    model: null
                },
                rules: {
                    selectedIntreval: [
                        {required: true, validator: Utils.checkDateTimeRange, trigger: 'blur'}
                    ],
                    competitor: [
                        {required: true, message: 'Please select Competitor', trigger: 'change'}
                    ],
                    model: [
                        {required: true, message: 'Please select Model', trigger: 'change'}
                    ]
                }
            }
        },
        watch: {
            'raceParams.model'(val) {
                let m = this.sportClass.filter((item) => {
                    if (item.id === val) return item;
                });
                if (this.entity) {
                    Utils.updateEntityModel(this.entity, m[0], window.Cesium, window.viewer);
                }
            }
        },
        methods: {
            handleClose: function () {
                this.closeWindow();
                this.$emit("visible-change", false);
                this.$emit("on-close", null);
            },
            frameLoaded: function () {
                console.log('Frame with Track Cesium is loaded');
            },
            changeTimeInterval(values) {
                return new window.Cesium.TimeIntervalCollection([
                    new window.Cesium.TimeInterval({
                        start: window.Cesium.JulianDate.fromDate(new Date(values[0])),
                        stop: window.Cesium.JulianDate.fromDate(new Date(values[1]))
                    })
                ]);
            },
            init: function () {
                this.loading = true;
                getDevices().then(response => {
                    this.devices = response;
                    this.raceParams.competitor = response[0].id;
                    SportClassUtils.getSportClass().then(resp => {
                        this.sportClass = Utils.selectBoatOnly(resp);
                        this.raceParams.model = resp[0].id;
                    });
                }).finally(() => {
                    this.loading = false;
                });
            },
            updateInterval: function (val) {
                this.raceParams.selectedIntreval = val;
            },
            handleSave: function () {
                this.validateForm('raceForm');
            },
            getRandomColor() {
                // '#'+(Math.random()*0xFFFFFF<<0).toString(16);
                const letters = '0123456789ABCDEF';
                let color = '';
                for (let i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
                return color;
            },
            prepareGpxData() {
                let entityProps = window.viewer.dataSources._dataSources[0].entities._entities.values[0].position._property;
                let enitityPositions = Utils.cartesianToDegrees(entityProps._values, window.Cesium);
                const {min, max} = window.viewer.slider.limits;
                return entityProps._times.reduce((prevValue, item, i) => {
                    const time = window.Cesium.JulianDate.toDate(item).getTime()
                    if (time >= min && time <= max) {
                        return prevValue = [...prevValue, {
                            time: time,
                            lon: enitityPositions[i].lon,
                            lat: enitityPositions[i].lat,
                            alt: enitityPositions[i].alt
                        }];
                    } else {
                        return prevValue;
                    }
                }, []);
            },
            getSelectedDevice: function () {
                let dev = null;
                for (let index in this.devices) {
                    dev = this.devices[index];
                    if (dev.id === this.raceParams.competitor) {
                        return dev;
                    }
                }
                return null;
            },
            findCompetitorByName: function () {
                let dev = this.getSelectedDevice();
                let competitor;
                for (let index in this.data.selectedEvent.competitors) {
                    competitor = this.data.selectedEvent.competitors[index];
                    if (competitor.shortName == dev.label || competitor.longName == dev.label) {
                        return competitor;
                    }
                }
                return {
                    color: this.getRandomColor(),
                    shortName: dev.label,
                    longName: dev.label,
                    country: {id: 182}
                };
            },
            findBoat: function () {
                let dev = this.getSelectedDevice();
                let boat;
                for (let index in this.data.selectedEvent.boats) {
                    boat = this.data.selectedEvent.boats[index];
                    if (boat.device.id == dev.id) {
                        return boat;
                    }
                }
                return {
                    name: dev.label,
                    boatNumber: 1,
                    sportClass: {id: this.raceParams.model}
                };
            },
            closeWindow: function () {
                window.viewer.slider.destroy();
                window.viewer.entities.removeAll();
                window.viewer.dataSources.removeAll();
                console.log('handleClose');
                //window.viewer.shouldAnimate = false;
                window.viewer.destroy();
                window.viewer = null;
            },
            validateForm: function (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$confirm(this.$t('track.loadTrack.message') + this.getSelectedDevice().label + '?', this.$t('track.loadTrack.header'), {
                            confirmButtonText: this.$t('common.buttonYes'),
                            cancelButtonText: this.$t('common.buttonNo'),
                            center: true,
                            type: 'warning'
                        }).then(() => {
                            this.loading = true;
                            //alert('Save track for event: ' + this.data.selectedEvent.name);
                            const request = {
                                trackStart: window.viewer.slider.limits.min,
                                trackEnd: window.viewer.slider.limits.max,
                                eventId: this.data.selectedEvent.id,
                                coordinates: this.prepareGpxData(),
                                deviceId: this.raceParams.competitor,
                                boat: this.findBoat(),
                                competitor: this.findCompetitorByName()
                            };
                            TrackUtils.uploadFullTrack(request).then(response => {
                                this.closeWindow();
                                this.$emit("visible-change", false);
                                this.$emit("on-close", response);
                            }).catch(error => {
                                console.log("Error with loadu=ing track: " + error);
                                this.loading = false;
                                Utils.showMessage(this, "Ошибка!", "Ошибка при сохранении трека! Возможно Вы его уже загрузили.");
                            }).finally(() => {
                                this.loading = false;
                            });
                        });
                    } else {
                        Utils.showMessage(this, "Ошибка ввода данных", "Проверьте правильность введенных данных");
                    }
                });
            }
        }
    }
</script>

<style>
    .track_modal .el-dialog--center .el-dialog__body {
        padding: 0;
    }

    .track_modal .el-main {
        padding: 0 0 10px 0;
    }

    .track_modal .cesium-viewer {
        height: calc(100vh - 220px) !important;
    }

    .track_modal .el-dialog--center .el-dialog__body {
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 0;
    }

    .el-container {
        position: initial !important;
    }

    .el-loading-mask {
        z-index: 9999;
    }
</style>
